/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import modals from '../../constants/modals';

type TModalName = (typeof modals)[keyof typeof modals];

interface IModal {
  name: TModalName;
  props?: { [key: string]: any };
}

interface IModalsState {
  openedModals: IModal[];
}

const initialState = {
  openedModals: [],
} as IModalsState;

const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    openModal(state, action: PayloadAction<{ name: TModalName; props?: { [key: string]: any } }>) {
      const isModalOpened = state.openedModals.some(({ name }) => name === action.payload.name);

      if (!isModalOpened) {
        state.openedModals.push(action.payload);
      }
    },
    closeModal(state, action: PayloadAction<TModalName>) {
      state.openedModals = state.openedModals.filter(({ name }) => name !== action.payload);
    },
  },
});

export const { openModal, closeModal } = modalsSlice.actions;

export default modalsSlice.reducer;
